import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'
import { toFilterOptions } from '@util/filter'

import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useAansluitingValuelists } from '../../../valuelists/hooks/useAansluitingValuelists'
import { useValuelists } from '../../../valuelists/hooks/useValuelists'
import { AssignedBijlagenFilters } from '../components/AssignedBijlagenFilters'
import { AssignedBijlagenTableRow } from '../components/AssignedBijlagenTableRow'
import { useAssignedBijlagenSearch } from '../hooks/useAssignedBijlagenSearch'

const headerCells = [
  { id: 'expired', numeric: false, label: '', fixed: 25 },
  { id: 'documentsoort', numeric: false, label: 'Documentsoort', fixed: 200 },
  {
    id: 'dueWeek',
    numeric: false,
    label: 'Opleveren voor',
    fixed: 100,
    sort: true,
  },
  {
    id: 'created.date',
    numeric: false,
    label: 'Aangemaakt',
    fixed: 50,
    sort: true,
  },
  {
    id: 'created.organisatie',
    numeric: false,
    label: 'Aangemaakt door',
    fixed: 100,
    sort: true,
  },
  {
    id: 'assignedTo',
    numeric: false,
    label: 'Toegewezen aan',
    fixed: 150,
    sort: true,
  },
  { id: 'entity', numeric: false, label: 'Horend bij', fixed: 75, sort: true },
  {
    id: 'searchValues.adres',
    numeric: false,
    label: 'Adres',
    fixed: 125,
    sort: true,
  },
  { id: 'gebiedscode', numeric: false, label: 'Gebied & labels', fixed: 100 },
  { id: 'actions', numeric: false, label: 'Details', fixed: 75 },
] as const

export const AssignedBijlagen = () => {
  const { data: valuelists } = useValuelists()
  const { data: aansluitingValuelists } = useAansluitingValuelists()
  const {
    data: { items: assignedBijlagen, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangeSort,
    onChangePage,
    filters,
    sort,
    onReset,
    onRefresh,
  } = useAssignedBijlagenSearch()

  return (
    <Page
      title={['Bijlagen', 'Aansluiting']}
      breadcrumbs={[
        { label: 'Aansluiting', href: '/home', tooltip: 'CAPO home' },
        { label: 'Bijlagen' },
      ]}
      fillScreen
    >
      <PageSection id="bijlagen" heading="Overzicht van uw bijlagen" />

      <Paper>
        <AssignedBijlagenFilters
          filters={filters}
          initialFilters={initialFilters}
          onChange={onChangeFilters}
          onReset={onReset}
          onRefresh={onRefresh}
          filterOptions={{
            ...valuelists,
            ...aansluitingValuelists,
            labels: toFilterOptions(aansluitingValuelists.labels),
          }}
        />
        <StyledTable
          headerCells={headerCells}
          loading={isLoading}
          onChangePage={onChangePage}
          onChangeSort={onChangeSort}
          sort={sort}
          stats={{ count, skip, limit }}
          isError={isError}
        >
          {assignedBijlagen.map((assignedBijlage) => {
            return (
              <AssignedBijlagenTableRow
                assignedBijlage={assignedBijlage}
                key={assignedBijlage._id}
              />
            )
          })}
        </StyledTable>
      </Paper>
    </Page>
  )
}
